import script from "./WeekReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeekReport.vue?vue&type=script&lang=ts&setup=true"

import "./WeekReport.vue?vue&type=style&index=0&id=1ab26002&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab26002"]])

export default __exports__